import { RULE_RUN_LEVEL } from '@/consts.js';
import BaseEntity from '@/entities/BaseEntity';

export default class StopRuleSettings extends BaseEntity {
  stop_outdated_ads = true;
  level = RULE_RUN_LEVEL.AD;
}
